var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix mt15pb20 mb20", attrs: { "data-test": "intro" } },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "feature",
              "comment-highlights": _vm.commentHighlights,
              "text-count-class": "company-info",
              "text-counts": _vm.textCounts,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tl fll row-left" }, [
        _vm.catchCopy
          ? _c("p", {
              staticClass: "fwB fs15 mb10",
              attrs: {
                id: _vm.targetIdMap.companyInfo.intro.catchCopy,
                "data-test": "intro-catch",
              },
              domProps: { textContent: _vm._s(_vm.catchCopy) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.text
          ? _c("p", {
              staticClass: "pega-pre-wrap",
              attrs: {
                id: _vm.targetIdMap.companyInfo.intro.text,
                "data-test": "intro-text",
              },
              domProps: { textContent: _vm._s(_vm.text) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flr ml25 company-img-main" }, [
        _vm.image && _vm.image.id
          ? _c("img", {
              attrs: {
                id: _vm.targetIdMap.companyInfo.intro.image,
                src: _vm.getPhotoUrl(_vm.image),
                "data-test": "introImage",
              },
              on: {
                load: function ($event) {
                  return _vm.$emit("onLoadImage")
                },
                error: function ($event) {
                  return _vm.$emit("onLoadImage")
                },
              },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }